<template>    
  <v-layout column>
    <v-layout>
      <top-info-panel>
        <v-flex xs12 md12 lg8 xl5 px-2 slot="content">
          <h4>Beheer assets</h4>
          <p>
            Via het beheer van assets kunt u uw assets configureren. Zo kunt u de assets aan een groep toekennen, de naamgeving aanpassen of de extra velden invullen.
          </p>
        </v-flex>
      </top-info-panel>
    </v-layout>
    <asset-overview ref="assetOverview" @assetSelected="selectAsset"></asset-overview>
    <v-dialog persistent v-if="selectedAsset && selectedAsset.id" v-model="dialog" width="1000" >     
        <v-card > 
            <v-card-title class="grey lighten-3">                    
                <h4>{{selectedAsset.name}} bewerken</h4>                    
            </v-card-title>
            <v-card-text >
                <edit-asset :asset="selectedAsset" :showCancelButton="true" @cancelled="selectedAsset=null" @assetSaved="assetSaved()" ></edit-asset>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import * as types from "../../store/types"
import { mapGetters } from "vuex"
import TopInfoPanel from '../../components/global/TopInfoPanel'
import VWidget from '../../components/global/VWidget'
import EditAsset from '../../components/asset/EditAsset'
import AssetOverview from "../../components/asset/AssetOverview";
import _ from 'lodash'

export default {
    components: {
        TopInfoPanel,
        VWidget,
        EditAsset,
        AssetOverview
    },
    data(){
        return {
            selectedAsset: null,
            dialog: null, 
        }
    },
    methods: {
         assetSaved(){
          
            this.selectedAsset=null

            this.$refs.assetOverview.loadData()
         },
        selectAsset(asset){
            this.selectedAsset = asset
            this.dialog = true
        },
        
    },
    
}
</script>